import React from "react";
import { Col, Row } from "reactstrap";
import ToggleSwitch from "../../common/controls/ToggleSwitch/ToggleSwitch";
import ReadOnlyField from "../../common/ReadOnlyField";
import formatDate from "../../common/utils";

function formatSource(source) {
  if (source === "manual") return "Manual (super-user)";
  if (source === "crm_sync") return "CRM sync";
  return "-";
}

function KeyAccountSection({ data, setValue, canToggle, disabled }) {
  const isKeyAccount = Boolean(data.is_key_account);
  const interactive = canToggle && !disabled;

  const onToggle = (e) => {
    if (!interactive) return;
    setValue("is_key_account", Boolean(e.target.checked));
  };

  const borderColor = isKeyAccount ? "var(--primary, #1d8cf8)" : "rgba(255,255,255,0.12)";

  return (
    <div className="px-3 py-3 mb-3 rounded border-2" style={{ borderColor }}>
      <h5 className="card-category mb-3">Key Account Pre-Settings</h5>

      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <p className="mb-1" style={{ fontSize: "0.875rem" }}>
            Flag this store as a Key Account
          </p>
        </div>
        <div className="d-flex align-items-center ml-3" style={{ gap: "0.5rem" }}>
          <ToggleSwitch name="is_key_account" checked={isKeyAccount} onChange={onToggle} disabled={!interactive} />
        </div>
      </div>

      <Row>
        <Col md={4}>
          <ReadOnlyField label="Activation date" value={formatDate(data.key_account_activated_at)} />
        </Col>
        <Col md={4}>
          <ReadOnlyField label="Activated by" value={data.key_account_activated_by_email || "-"} />
        </Col>
        <Col md={4}>
          <ReadOnlyField label="Source" value={formatSource(data.key_account_activation_source)} />
        </Col>
      </Row>

      <div
        className="mt-3 px-3 py-2 rounded"
        style={{
          background: "rgba(29,140,248,0.08)",
          borderLeft: "3px solid var(--primary, #1d8cf8)",
          fontSize: "0.8rem",
        }}
      >
        <strong>Auto-sync from Salesforce:</strong> when a store&apos;s Salesforce account reaches VIP / Key Account
        status, this toggle flips ON automatically. The <em>Source</em> field records <code>Salesforce</code> in that
        case instead of a user email.
      </div>
    </div>
  );
}

export default KeyAccountSection;
